



















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from './fetchMS';

import { ParamApi, FiltersApi, DateType } from './models/BajasCobranza.models';

@Component({ components: { DatePicker } })
export default class BajasCobranzaFilters extends Vue {
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  paramApi: ParamApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    typeDate: {
      id_date: 1,
      name_date: 'Fecha Creación',
    },
  };

  startDateName: string = 'Fecha Creación Inicio';
  endDateName: string = 'Fecha Creación Fin';
  filterApi: FiltersApi = {};

  async mounted() {
    await this.getFilters();
    this.handleFilters();
  }

  handleSearchFilter() {
    this.handleFilters();
  }

  handleCleanFilters() {
    this.paramApi = {};
    this.paramApi.typeDate = {
      id_date: 1,
      name_date: 'Fecha Creación',
    };
    this.paramApi.start_date = moment().subtract(1, 'month');
    this.paramApi.end_date = moment();
    const params = { ...this.paramApi };
    this.$emit('filters', params);
  }

  handleFilters() {
    this.startDateName = `${this.paramApi.typeDate.name_date ||
      'Fecha Creación'} Inicio`;
    this.endDateName = `${this.paramApi.typeDate.name_date ||
      'Fecha Creación'} Fin`;
    const params = { ...this.paramApi };
    this.$emit('filters', params);
  }

  @Watch('paramApi.start_date')
  startDateChange() {
    if (this.paramApi.start_date > this.paramApi.end_date) {
      this.paramApi.end_date = this.paramApi.start_date;
    }
    this.handleFilters();
  }

  @Watch('paramApi.end_date')
  endDateChange() {
    if (this.paramApi.end_date < this.paramApi.start_date) {
      this.paramApi.start_date = this.paramApi.end_date;
    }
    this.handleFilters();
  }

  async getFilters() {
    try {
      this.loadingService.showLoading(null, 'get');
      const result = await fetchMS({ endpoint: 'get_filters' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTERS } = result.data;
      if (Number(CODIGO_RESPUESTA) !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      FILTERS.TYPE_DATES
        ? FILTERS.TYPE_DATES.sort((a: DateType, b: DateType) => {
            const optionA = (a.name_date || '').toLowerCase();
            const optionB = (b.name_date || '').toLowerCase();

            if (optionA < optionB) return -1;
            if (optionA > optionB) return 1;
            return 0;
          })
        : [];
      this.filterApi = { ...FILTERS };
      console.log(this.filterApi);
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('get');
    }
  }
}
